import { useAllocationRuleGraphRetrieveSuspense } from "gen/endpoints/allocation-rule-graph/allocation-rule-graph";
import { AllocationRuleGraphData } from "gen/model/allocationRuleGraphData";
import { GenericTableTextBadge } from "gen/model/genericTableTextBadge";
import { TFunction } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export type AllocationRuleGraphTabProps = {
  fundFamilyId: string;
  ruleGraphUseId?: string;
};

export const AllocationRuleGraphPage: React.FC = () => {
  const { t } = useTranslation(["allocation"]);
  const { allocationRuleGraphUseId } = useParams();

  const { fundFamilyId, allocationRuleGraphId } = useRequiredStringParams();

  const { data: graphTableData } = useAllocationRuleGraphRetrieveSuspense(
    fundFamilyId,
    allocationRuleGraphId,
  );

  const tabProps: AllocationRuleGraphTabProps = {
    fundFamilyId,
    ruleGraphUseId: allocationRuleGraphUseId,
  };
  return (
    <PageContent isFullHeight={true}>
      <PageHeader
        title={graphTableData.name}
        badge={getAllocationRuleIsDefaultBadge(graphTableData, t)}
        backButton={{
          path: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .fundStructure({}).$,
          title: t("allocation:detailedGraphView.backToAll"),
        }}
      />
      <PageBody>
        <PageTabs context={tabProps} />
      </PageBody>
    </PageContent>
  );
};

export const getAllocationRuleIsDefaultBadge = (
  data: AllocationRuleGraphData,
  t: TFunction<["allocation"]>,
): GenericTableTextBadge | undefined => {
  if (data.is_default) {
    return {
      type: "text",
      color: "success",
      text: t("allocation:ruleGraphDetails.default"),
    };
  }
};
